import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

import { getUserPaymentMethods, setDefaultPaymentMethod, deletePaymentMethod } from '@/utils/stripe-tools'
import { auth } from '@/firebase'

/**
 * Hook to fetch user's payment methods
 * @returns {object} Query object with payment methods data
 */
export const useUserPaymentMethods = () => {
  return useQuery({
    queryKey: ['userPaymentMethods', auth.currentUser?.uid],
    queryFn: getUserPaymentMethods,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    enabled: !!auth.currentUser, // Only run if user is authenticated
  })
}

/**
 * Hook to set default payment method
 * @returns {object} Mutation object
 */
export const useSetDefaultPaymentMethod = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: setDefaultPaymentMethod,
    onSuccess: () => {
      // Invalidate and refetch payment methods
      queryClient.invalidateQueries(['userPaymentMethods'])
      queryClient.invalidateQueries(['userSubscription'])
    },
  })
}

/**
 * Hook to delete payment method
 * @returns {object} Mutation object
 */
export const useDeletePaymentMethod = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deletePaymentMethod,
    onSuccess: () => {
      // Invalidate and refetch payment methods
      queryClient.invalidateQueries(['userPaymentMethods'])
    },
  })
}
